<template>
    <div id="DocumentCollection" >
        <q-dialog v-model="dialog">
            <q-card style="width: 400px; height: 500px">
                <q-card-section class="row items-center">
<!--                    <div class="text-h6">Document Collection</div>-->
                    <q-space/>
                    <q-btn dense flat icon="close" round v-close-popup/>
                </q-card-section>

                <q-card-section>
                    <h5 class="text-center mt-3" style="text-transform: capitalize;">{{message}}</h5>
                    <div style="width: 100%; height: 100px;">
                        <img src="../assets/document_collected.png" class="w-100"  alt="">
                    </div>

                </q-card-section>
            </q-card>
        </q-dialog>

        <div class="doc-container">
            <div class="row">
                <div class="col-8 q-pa-md">
                    <div class="doc-logo q-pa-md">
                        <img src="../assets/logo-old-1.png"  alt="">
                    </div>
                    <div class="doc-content q-pa-md d-flex justify-between" style="align-items: center">
                        <div>
                            <h1 class="mb-0">Upload document</h1>
                            <p>Please upload digital photos of the following documents.</p>
                        </div>
                        <div>
                            <h6 style="color: #4e4e4e">{{applicationDetail.name}}</h6>
                            <span style="color: grey">{{applicationDetail.userName}}</span>
                            <span style="color: grey" class="ml-1 mb-4">(#{{applicationDetail.ApplicationId}})</span>
                        </div>
                    </div>

                    <div class="row" v-if="applicationDetail&& !applicationDetail.documents">
                        <div class="col-4 q-pa-md" v-if="applicationDetail.partnerType !== Constants.RP">
                            <div class="upload-card" >
                                <div class="transferType mb-3">
                                    <input @change="loadGstin($event)" accept="application/pdf, image/*" class="mb-2"
                                           id="uploadGstin" type="file" style="display: none">

                                    <div :class="fileDataURI_gstin?'':'image-box'" @click="openFile('uploadGstin')" class="mx-auto">
                                        <div v-if="fileDataURI_gstin && file_gstin.type==='application/pdf'">
                                            <div style="width: 250px; height: 250px;" class="mx-auto mb-4">
                                                <img src="../assets/pdf.png" alt="" class="w-100" >
                                            </div>
                                            <!--                                        <q-btn @click.stop="" class="pd-btn mx-auto w-50 d-block" :href="fileDataURI_gstin" target="_blank">PREVIEW</q-btn>-->
                                        </div>
                                        <div v-else-if="fileDataURI_gstin" style=" height: 350px;" class="mx-auto mb-4">
                                            <img :src="fileDataURI_gstin"  class="w-100">
                                        </div>
                                        <div  v-else>
                                            <div class="doc-upload-icon">
                                                <img src="../assets/file.svg" class="d-block mx-auto" alt="">
<!--                                                <i class="material-icons icon-cloud">cloud_upload</i>-->
                                                <p class="mt-3">GSTIN</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-4 q-pa-md">
                            <div class="upload-card" >
                                <div class="transferType mb-3">
                                    <input @change="loadPan($event)" accept="application/pdf, image/*" class="mb-2"
                                           id="uploadPan" type="file" style="display: none">
                                    <div :class="fileDataURI_pan?'':'image-box'" @click="openFile('uploadPan')" class="mx-auto">
                                        <div v-if="fileDataURI_pan && file_pan.type==='application/pdf'">
                                            <div style="width: 250px; height: 250px;" class="mx-auto mb-4">
                                                <img src="../assets/pdf.png" alt="" class="w-100" >
                                            </div>
                                            <q-btn @click.stop="" class="pd-btn mx-auto w-50 d-block" :href="fileDataURI_pan" target="_blank">PREVIEW</q-btn>
                                        </div>
                                        <div v-else-if="fileDataURI_pan" style="height: 350px;" class="mx-auto mb-4">
                                            <img :src="fileDataURI_pan"  class="w-100">
                                        </div>

                                        <div  v-else>
                                            <div class="doc-upload-icon">
                                                <img src="../assets/file.svg" class="d-block mx-auto" alt="">
                                                <!--                                                <i class="material-icons icon-cloud">cloud_upload</i>-->
                                                <p class="mt-3">PAN</p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-4 q-pa-md" v-if="applicationDetail.partnerType === Constants.RP">
                            <div class="transferType upload-card mb-3">
                                <input @change="loadAadhaarFront($event)" accept="application/pdf, image/*" class="mb-2"
                                       id="uploadAadhaarFront" type="file" style="display: none">
                                <div :class="fileDataURI_aadhaarFront?'':'image-box'" @click="openFile('uploadAadhaarFront')" class="mx-auto">
                                    <div v-if="fileDataURI_aadhaarFront && file_aadhaarFront.type==='application/pdf'">
                                        <div style="width: 250px; height: 250px;" class="mx-auto mb-4">
                                            <img src="../assets/pdf.png" alt="" class="w-100" >
                                        </div>
                                        <q-btn @click.stop="" class="pd-btn mx-auto w-50 d-block" :href="fileDataURI_aadhaarFront" target="_blank">PREVIEW</q-btn>
                                    </div>
                                    <div v-else-if="fileDataURI_aadhaarFront" style="height: 350px;" class="mx-auto mb-4">
                                        <img :src="fileDataURI_aadhaarFront"  class="w-100">
                                    </div>
                                    <div  v-else>
                                        <div class="doc-upload-icon">
                                            <img src="../assets/file.svg" class="d-block mx-auto" alt="">
                                            <!--                                                <i class="material-icons icon-cloud">cloud_upload</i>-->
                                            <p class="mt-3">Aadhaar Front</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-4 q-pa-md" v-if="applicationDetail.partnerType === Constants.RP">
                            <div class="transferType upload-card mb-3">
                                <input @change="loadAadhaarBack($event)" accept="application/pdf, image/*" class="mb-2"
                                       id="uploadAadhaarBack" type="file" style="display: none">
                                <div :class="fileDataURI_aadhaarBack?'':'image-box'" @click="openFile('uploadAadhaarBack')" class="mx-auto">
                                    <div v-if="fileDataURI_aadhaarBack && file_aadhaarBack.type==='application/pdf'">
                                        <div style="width: 250px; height: 250px;" class="mx-auto mb-4">
                                            <img src="../assets/pdf.png" alt="" class="w-100" >
                                        </div>
                                        <q-btn @click.stop="" class="pd-btn mx-auto w-50 d-block" :href="fileDataURI_aadhaarBack" target="_blank">PREVIEW</q-btn>
                                    </div>
                                    <div v-else-if="fileDataURI_aadhaarBack" style="height: 350px;" class="mx-auto mb-4">
                                        <img :src="fileDataURI_aadhaarBack"  class="w-100">
                                    </div>
                                    <div  v-else>
                                        <div class="doc-upload-icon">
                                            <img src="../assets/file.svg" class="d-block mx-auto" alt="">
                                            <!--                                                <i class="material-icons icon-cloud">cloud_upload</i>-->
                                            <p class="mt-3">Aadhaar Back</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <q-btn @click="startUploadDocuments" class="pd-btn mr-3 float-right mb-3 d-block " >Upload Documents</q-btn>
                        </div>
                    </div>

                    <div v-else>
                        <div class="row" v-if="applicationDetail">
                            <div class="col-4 q-pa-md" v-if="applicationDetail.partnerType !== Constants.RP">
                                <div class="upload-image position-relative scheme-upload-box">
                                    <label class="">GSTIN</label>
                                    <!--                            <div class="upload-position ">-->
                                    <!--                                <div class="upload-button position-relative">-->
                                    <!--                                   -->
                                    <!--                                </div>-->
                                    <!--                            </div>-->
                                    <div style="height: 350px; width: 100%;" class="overflow-hidden" v-if="applicationDetail.documents && applicationDetail.documents.doc2.url &&
                                 ['jpeg','jpg','png','tiff','gif','psd','raw','ai','indd'].includes(applicationDetail.documents.doc2.url.split('.').pop().toString().toLowerCase())">
                                        <img :src="applicationDetail.documents.doc2.url" class="d-block mx-auto w-100">
                                    </div>
                                    <div class="document position-relative"
                                         v-else-if="applicationDetail.documents && applicationDetail.documents.doc2.url">
                                        <img alt="pdf" class="d-block mx-auto" style="height: 150px" src="../../src/assets/pdf.png">
                                        <a :href="applicationDetail.documents.doc2.url"
                                           class="download-pdf position-absolute" style="top: 170px" target="_blank">DOWNLOAD</a>
                                    </div>

                                </div>
                            </div>
                            <div class="col-4 q-pa-md">
                                <div class="upload-image position-relative scheme-upload-box">
                                    <label class="">PAN</label>
                                    <!--                            <div class="upload-position ">-->
                                    <!--                                <div class="upload-button position-relative">-->

                                    <!--                                </div>-->
                                    <!--                            </div>-->
                                    <div style="height: 350px; width: 100%;" class="overflow-hidden" v-if="applicationDetail.documents && applicationDetail.documents.doc1.url &&
                                 ['jpeg','jpg','png','tiff','gif','psd','raw','ai','indd'].includes(applicationDetail.documents.doc1.url.split('.').pop().toString().toLowerCase())">
                                        <img :src="applicationDetail.documents.doc1.url" class="d-block mx-auto w-100">
                                    </div>
                                    <div class="document position-relative"
                                         v-else-if="applicationDetail.documents && applicationDetail.documents.doc1.url">
                                        <img alt="pdf" class="d-block mx-auto" style="height: 150px" src="../../src/assets/pdf.png">
                                        <a :href="applicationDetail.documents.doc1.url"
                                           class="download-pdf position-absolute" style="top: 170px" target="_blank">DOWNLOAD</a>
                                    </div>

                                </div>
                            </div>
                            <div class="col-4 q-pa-md" v-if="applicationDetail.partnerType === Constants.RP">
                                <div class="upload-image position-relative scheme-upload-box">
                                    <label class="">Aadhaar Front</label>
                                    <div style="height: 350px; width: 100%;" class="overflow-hidden" v-if="applicationDetail.documents && applicationDetail.documents.aadhaarFront.url &&
                                 ['jpeg','jpg','png','tiff','gif','psd','raw','ai','indd'].includes(applicationDetail.documents.aadhaarFront.url.split('.').pop().toString().toLowerCase())">
                                        <img :src="applicationDetail.documents.aadhaarFront.url" class="d-block mx-auto w-100">
                                    </div>
                                    <div class="document position-relative"
                                         v-else-if="applicationDetail.documents && applicationDetail.documents.aadhaarFront.url">
                                        <img alt="pdf" class="d-block mx-auto" style="height: 150px" src="../../src/assets/pdf.png">
                                        <a :href="applicationDetail.documents.aadhaarFront.url"
                                           class="download-pdf position-absolute" style="top: 170px" target="_blank">DOWNLOAD</a>
                                    </div>

                                </div>
                            </div>
                            <div class="col-4 q-pa-md" v-if="applicationDetail.partnerType === Constants.RP">
                                <div class="upload-image position-relative scheme-upload-box">
                                    <label class="">Aadhaar Back</label>
                                    <div style="height: 350px; width: 100%;" class="overflow-hidden" v-if="applicationDetail.documents && applicationDetail.documents.aadhaarBack.url &&
                                 ['jpeg','jpg','png','tiff','gif','psd','raw','ai','indd'].includes(applicationDetail.documents.aadhaarBack.url.split('.').pop().toString().toLowerCase())">
                                        <img :src="applicationDetail.documents.aadhaarBack.url" class="d-block mx-auto w-100">
                                    </div>
                                    <div class="document position-relative"
                                         v-else-if="applicationDetail.documents && applicationDetail.documents.aadhaarBack.url">
                                        <img alt="pdf" class="d-block mx-auto" style="height: 150px" src="../../src/assets/pdf.png">
                                        <a :href="applicationDetail.documents.aadhaarBack.url"
                                           class="download-pdf position-absolute" style="top: 170px" target="_blank">DOWNLOAD</a>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-4 doc-right-div" style="height: 100vh;">
                    <div class="doc-right-img">
                        <img src="../assets/Doc_upload.svg" class="w-100 d-block mx-auto" alt="">
                    </div>
                </div>
            </div>

        </div>








<!--            <div class="row q-pa-md ">-->
<!--                <div class="col-8 q-pa-md" style="background: #006755">-->
<!--                    <div class="row">-->
<!--                        <div class="col-6">-->
<!--                            <h4 style="font-weight: 300" class="mb-4 text-white">Application Detail</h4>-->
<!--                            <template v-if="applicationDetail">-->
<!--                                <h6 class="text-white">{{applicationDetail.name}}</h6>-->
<!--                                <span class=" text-white">{{applicationDetail.userName}}</span>-->
<!--                                <span class="ml-1 mb-4 text-white">(#{{applicationDetail.ApplicationId}})</span>-->
<!--                            </template>-->
<!--                        </div>-->
<!--                        <div class="col-6">-->
<!--                            <img alt="" class="mx-auto d-block w-50" src="../assets/uploadDocument.png">-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

<!--                <div class="col-8 " style="border: 1px solid #006755" v-if="applicationDetail&& !applicationDetail.documents">-->
<!--                    <div class="row">-->
<!--                        <div class="col-6" v-if="applicationDetail.partnerType !== Constants.RP">-->
<!--                            <h6 class="mb-1" style="font-size: 18px;  margin-left: 96px;">GSTIN</h6>-->

<!--                            <div class="transferType mb-3">-->
<!--                                <input @change="loadGstin($event)" accept="application/pdf, image/*" class="mb-2"-->
<!--                                       id="uploadGstin" type="file" style="display: none">-->
<!--                                <div :class="fileDataURI_gstin?'':'image-box'" @click="openFile('uploadGstin')" class="mx-auto">-->
<!--                                    <div v-if="fileDataURI_gstin && file_gstin.type==='application/pdf'">-->
<!--                                        <div style="width: 250px; height: 250px;" class="mx-auto mb-4">-->
<!--                                            <img src="../assets/pdf.png" alt="" class="w-100" >-->
<!--                                        </div>-->
<!--&lt;!&ndash;                                        <q-btn @click.stop="" class="pd-btn mx-auto w-50 d-block" :href="fileDataURI_gstin" target="_blank">PREVIEW</q-btn>&ndash;&gt;-->
<!--                                    </div>-->
<!--                                    <div v-else-if="fileDataURI_gstin" style="width: 250px; height: 250px;" class="mx-auto mb-4">-->
<!--                                        <img :src="fileDataURI_gstin"  class="w-100">-->
<!--                                    </div>-->
<!--                                    <i v-else class="material-icons icon-cloud">cloud_upload</i>-->
<!--                                </div>-->
<!--                            </div>-->

<!--&lt;!&ndash;                            <div style="width: 200px; height: 200px; overflow: hidden">&ndash;&gt;-->
<!--&lt;!&ndash;                                <img class="w-100" id="gstinOutput"/>&ndash;&gt;-->
<!--&lt;!&ndash;                            </div>&ndash;&gt;-->
<!--                        </div>-->

<!--                        <div class="col-6">-->
<!--                            <h6 class="mb-1" style="font-size: 18px; margin-left: 96px;">PAN</h6>-->
<!--                            <div class="transferType mb-3">-->
<!--                                <input @change="loadPan($event)" accept="application/pdf, image/*" class="mb-2"-->
<!--                                       id="uploadPan" type="file" style="display: none">-->
<!--                                <div :class="fileDataURI_pan?'':'image-box'" @click="openFile('uploadPan')" class="mx-auto">-->
<!--                                    <div v-if="fileDataURI_pan && file_pan.type==='application/pdf'">-->
<!--                                        <div style="width: 250px; height: 250px;" class="mx-auto mb-4">-->
<!--                                            <img src="../assets/pdf.png" alt="" class="w-100" >-->
<!--                                        </div>-->
<!--                                        <q-btn @click.stop="" class="pd-btn mx-auto w-50 d-block" :href="fileDataURI_pan" target="_blank">PREVIEW</q-btn>-->
<!--                                    </div>-->
<!--                                    <div v-else-if="fileDataURI_pan" style="width: 250px; height: 250px;" class="mx-auto mb-4">-->
<!--                                        <img :src="fileDataURI_pan"  class="w-100">-->
<!--                                    </div>-->
<!--                                    <i v-else class="material-icons icon-cloud">cloud_upload</i>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->

<!--                        <div class="col-6" v-if="applicationDetail.partnerType === Constants.RP">-->
<!--                            <h6 class="mb-1" style="font-size: 18px; margin-left: 96px;">Aadhaar Front</h6>-->
<!--                            <div class="transferType mb-3">-->
<!--                                <input @change="loadAadhaarFront($event)" accept="application/pdf, image/*" class="mb-2"-->
<!--                                       id="uploadAadhaarFront" type="file" style="display: none">-->
<!--                                <div :class="fileDataURI_aadhaarFront?'':'image-box'" @click="openFile('uploadAadhaarFront')" class="mx-auto">-->
<!--                                    <div v-if="fileDataURI_aadhaarFront && file_aadhaarFront.type==='application/pdf'">-->
<!--                                        <div style="width: 250px; height: 250px;" class="mx-auto mb-4">-->
<!--                                            <img src="../assets/pdf.png" alt="" class="w-100" >-->
<!--                                        </div>-->
<!--                                        <q-btn @click.stop="" class="pd-btn mx-auto w-50 d-block" :href="fileDataURI_aadhaarFront" target="_blank">PREVIEW</q-btn>-->
<!--                                    </div>-->
<!--                                    <div v-else-if="fileDataURI_aadhaarFront" style="width: 250px; height: 250px;" class="mx-auto mb-4">-->
<!--                                        <img :src="fileDataURI_aadhaarFront"  class="w-100">-->
<!--                                    </div>-->
<!--                                    <i v-else class="material-icons icon-cloud">cloud_upload</i>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col-6" v-if="applicationDetail.partnerType === Constants.RP">-->
<!--                            <h6 class="mb-1" style="font-size: 18px; margin-left: 96px;">Aadhaar Back</h6>-->
<!--                            <div class="transferType mb-3">-->
<!--                                <input @change="loadAadhaarBack($event)" accept="application/pdf, image/*" class="mb-2"-->
<!--                                       id="uploadAadhaarBack" type="file" style="display: none">-->
<!--                                <div :class="fileDataURI_aadhaarBack?'':'image-box'" @click="openFile('uploadAadhaarBack')" class="mx-auto">-->
<!--                                    <div v-if="fileDataURI_aadhaarBack && file_aadhaarBack.type==='application/pdf'">-->
<!--                                        <div style="width: 250px; height: 250px;" class="mx-auto mb-4">-->
<!--                                            <img src="../assets/pdf.png" alt="" class="w-100" >-->
<!--                                        </div>-->
<!--                                        <q-btn @click.stop="" class="pd-btn mx-auto w-50 d-block" :href="fileDataURI_aadhaarBack" target="_blank">PREVIEW</q-btn>-->
<!--                                    </div>-->
<!--                                    <div v-else-if="fileDataURI_aadhaarBack" style="width: 250px; height: 250px;" class="mx-auto mb-4">-->
<!--                                        <img :src="fileDataURI_aadhaarBack"  class="w-100">-->
<!--                                    </div>-->
<!--                                    <i v-else class="material-icons icon-cloud">cloud_upload</i>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->

<!--                        <div class="col-12 mt-3 w-100">-->
<!--                            <q-btn @click="startUploadDocuments"  class="pd-btn float-right mb-3 d-block " style="background: #006755 !important; margin-right: 98px;   ">Upload Documents</q-btn>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->


<!--                <div class="col-8 mx-auto " style="border: 1px solid #006755" v-else>-->

<!--                    <div class="row" v-if="applicationDetail ">-->
<!--                        <div class="col-6 q-pa-md" v-if="applicationDetail.partnerType !== Constants.RP">-->
<!--                            <div class="upload-image position-relative scheme-upload-box">-->
<!--                                <label class="">GSTIN</label>-->
<!--    &lt;!&ndash;                            <div class="upload-position ">&ndash;&gt;-->
<!--    &lt;!&ndash;                                <div class="upload-button position-relative">&ndash;&gt;-->
<!--    &lt;!&ndash;                                   &ndash;&gt;-->
<!--    &lt;!&ndash;                                </div>&ndash;&gt;-->
<!--    &lt;!&ndash;                            </div>&ndash;&gt;-->
<!--                                <div style="height: 250px; width: 100%;" class="overflow-hidden" v-if="applicationDetail.documents && applicationDetail.documents.doc2.url &&-->
<!--                                 ['jpeg','jpg','png','tiff','gif','psd','raw','ai','indd'].includes(applicationDetail.documents.doc2.url.split('.').pop().toString().toLowerCase())">-->
<!--                                    <img :src="applicationDetail.documents.doc2.url" class="d-block mx-auto w-100">-->
<!--                                </div>-->
<!--                                <div class="document position-relative"-->
<!--                                     v-else-if="applicationDetail.documents && applicationDetail.documents.doc2.url">-->
<!--                                    <img alt="pdf" class="d-block mx-auto" style="height: 150px" src="../../src/assets/pdf.png">-->
<!--                                    <a :href="applicationDetail.documents.doc2.url"-->
<!--                                       class="download-pdf position-absolute" style="top: 170px" target="_blank">DOWNLOAD</a>-->
<!--                                </div>-->

<!--                            </div>-->
<!--                        </div>-->

<!--                        <div class="col-6 q-pa-md">-->
<!--                            <div class="upload-image position-relative scheme-upload-box">-->
<!--                                <label class="">PAN</label>-->
<!--    &lt;!&ndash;                            <div class="upload-position ">&ndash;&gt;-->
<!--    &lt;!&ndash;                                <div class="upload-button position-relative">&ndash;&gt;-->

<!--    &lt;!&ndash;                                </div>&ndash;&gt;-->
<!--    &lt;!&ndash;                            </div>&ndash;&gt;-->
<!--                                <div style="height: 250px; width: 100%;" class="overflow-hidden" v-if="applicationDetail.documents && applicationDetail.documents.doc1.url &&-->
<!--                                 ['jpeg','jpg','png','tiff','gif','psd','raw','ai','indd'].includes(applicationDetail.documents.doc1.url.split('.').pop().toString().toLowerCase())">-->
<!--                                    <img :src="applicationDetail.documents.doc1.url" class="d-block mx-auto w-100">-->
<!--                                </div>-->
<!--                                <div class="document position-relative"-->
<!--                                     v-else-if="applicationDetail.documents && applicationDetail.documents.doc1.url">-->
<!--                                    <img alt="pdf" class="d-block mx-auto" style="height: 150px" src="../../src/assets/pdf.png">-->
<!--                                    <a :href="applicationDetail.documents.doc1.url"-->
<!--                                       class="download-pdf position-absolute" style="top: 170px" target="_blank">DOWNLOAD</a>-->
<!--                                </div>-->

<!--                            </div>-->
<!--                        </div>-->

<!--                        <div class="col-6 q-pa-md" v-if="applicationDetail.partnerType === Constants.RP">-->
<!--                            <div class="upload-image position-relative scheme-upload-box">-->
<!--                                <label class="">Aadhaar Front</label>-->
<!--                                <div style="height: 250px; width: 100%;" class="overflow-hidden" v-if="applicationDetail.documents && applicationDetail.documents.aadhaarFront.url &&-->
<!--                                 ['jpeg','jpg','png','tiff','gif','psd','raw','ai','indd'].includes(applicationDetail.documents.aadhaarFront.url.split('.').pop().toString().toLowerCase())">-->
<!--                                    <img :src="applicationDetail.documents.aadhaarFront.url" class="d-block mx-auto w-100">-->
<!--                                </div>-->
<!--                                <div class="document position-relative"-->
<!--                                     v-else-if="applicationDetail.documents && applicationDetail.documents.aadhaarFront.url">-->
<!--                                    <img alt="pdf" class="d-block mx-auto" style="height: 150px" src="../../src/assets/pdf.png">-->
<!--                                    <a :href="applicationDetail.documents.aadhaarFront.url"-->
<!--                                       class="download-pdf position-absolute" style="top: 170px" target="_blank">DOWNLOAD</a>-->
<!--                                </div>-->

<!--                            </div>-->
<!--                        </div>-->

<!--                        <div class="col-6 q-pa-md" v-if="applicationDetail.partnerType === Constants.RP">-->
<!--                            <div class="upload-image position-relative scheme-upload-box">-->
<!--                                <label class="">Aadhaar Back</label>-->
<!--                                <div style="height: 250px; width: 100%;" class="overflow-hidden" v-if="applicationDetail.documents && applicationDetail.documents.aadhaarBack.url &&-->
<!--                                 ['jpeg','jpg','png','tiff','gif','psd','raw','ai','indd'].includes(applicationDetail.documents.aadhaarBack.url.split('.').pop().toString().toLowerCase())">-->
<!--                                    <img :src="applicationDetail.documents.aadhaarBack.url" class="d-block mx-auto w-100">-->
<!--                                </div>-->
<!--                                <div class="document position-relative"-->
<!--                                     v-else-if="applicationDetail.documents && applicationDetail.documents.aadhaarBack.url">-->
<!--                                    <img alt="pdf" class="d-block mx-auto" style="height: 150px" src="../../src/assets/pdf.png">-->
<!--                                    <a :href="applicationDetail.documents.aadhaarBack.url"-->
<!--                                       class="download-pdf position-absolute" style="top: 170px" target="_blank">DOWNLOAD</a>-->
<!--                                </div>-->

<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>  -->
    </div>


</template>

<script>
  import { NetworkCommunicator } from '../plugins/NetworkResourceHandler'
  import Constants from '../Constants/Constant'
  import axios from 'axios'

  export default {
    name: 'DocumentCollection',
    data () {
      return {
        Constants: Constants,
        applicationDetail: null,
        formGstin: '',
        formPan: '',
        formAadhaarFront: '',
        formAadhaarBack: '',
        gstin: { path: '', url: '' },
        pan: { path: '', url: '' },
        aadhaarFront: { path: '', url: '' },
        aadhaarBack: { path: '', url: '' },
        stageId: '',
        dialog: false,
        message: '',
        file_gstin:'',
        fileDataURI_gstin:'',
        file_pan:'',
        fileDataURI_pan:'',
        file_aadhaarFront:'',
        fileDataURI_aadhaarFront:'',
        file_aadhaarBack:'',
        fileDataURI_aadhaarBack:'',
      }
    },
    mounted () {
      this.getApplicationDetail()
    },
    methods: {
      openFile(id){
        document.getElementById(id).click();
      },
      loadGstin (event) {
        // var output = document.getElementById('gstinOutput')
        // output.src = URL.createObjectURL(event.target.files[0])
        this.file_gstin = event.target.files[0]
        this.fileDataURI_gstin = URL.createObjectURL(event.target.files[0])
        this.formGstin = new FormData()
        this.formGstin.append('doc[]', event.target.files[0])
      },
      loadPan (event) {
        // var output = document.getElementById('panOutput')
        // output.src = URL.createObjectURL(event.target.files[0])
        this.file_pan = event.target.files[0]
        this.fileDataURI_pan = URL.createObjectURL(event.target.files[0])
        this.formPan = new FormData()
        this.formPan.append('doc[]', event.target.files[0])
      },
      loadAadhaarFront (event) {
        this.file_aadhaarFront = event.target.files[0]
        this.fileDataURI_aadhaarFront = URL.createObjectURL(event.target.files[0])
        this.formAadhaarFront = new FormData()
        this.formAadhaarFront.append('doc[]', event.target.files[0])
      },
      loadAadhaarBack (event) {
        this.file_aadhaarBack = event.target.files[0]
        this.fileDataURI_aadhaarBack = URL.createObjectURL(event.target.files[0])
        this.formAadhaarBack = new FormData()
        this.formAadhaarBack.append('doc[]', event.target.files[0])
      },
      startUploadDocuments () {
        if (this.applicationDetail.partnerType!==Constants.RP && document.getElementById('uploadGstin').files.length === 0) {
            this.$q.notify('Please Upload GSTIN')
        } else if(this.applicationDetail.partnerType===Constants.RP && document.getElementById('uploadAadhaarFront').files.length === 0) {
            this.$q.notify('Please Upload Aadhaar Front')
        } else if(this.applicationDetail.partnerType===Constants.RP && document.getElementById('uploadAadhaarBack').files.length === 0) {
            this.$q.notify('Please Upload Aadhaar Back')
        } else if(document.getElementById('uploadPan').files.length === 0) {
            this.$q.notify('Please Upload PAN')
        } else if(this.applicationDetail.partnerType!==Constants.RP) {
            this.uploadDocuments()
        } else if(this.applicationDetail.partnerType===Constants.RP) {
            this.uploadDocumentsForRP()
        }
      },
      async uploadDocuments () {
        let self = this
          axios.all([axios.post(Constants.api_url + 'upload', this.formPan), axios.post(Constants.api_url + 'upload', this.formGstin)])
              .then(axios.spread(function (panData, gstinData) {
                  // Both requests are now complete
                  self.pan = { path: panData.data.data.success[0].path, url: panData.data.data.success[0].url }
                  self.gstin = { path: gstinData.data.data.success[0].path, url: gstinData.data.data.success[0].url }
                  let document = { document: { doc1: self.pan, doc2: self.gstin } }
                  self.addDocumentsToApplication(document)
              }))
      },
        async uploadDocumentsForRP () {
        let self = this
            axios.all([axios.post(Constants.api_url + 'upload', this.formPan), axios.post(Constants.api_url + 'upload', this.formAadhaarFront),axios.post(Constants.api_url + 'upload', this.formAadhaarBack)])
                .then(axios.spread(function (panData, aadhaarFrontData, aadhaarBackData) {
                    // Both requests are now complete
                    self.pan = { path: panData.data.data.success[0].path, url: panData.data.data.success[0].url }
                    self.aadhaarFront = { path: aadhaarFrontData.data.data.success[0].path, url: aadhaarFrontData.data.data.success[0].url }
                    self.aadhaarBack = { path: aadhaarBackData.data.data.success[0].path, url: aadhaarBackData.data.data.success[0].url }
                    let document = { document: { doc1: self.pan, doc2: {url:'', path:''}, aadhaarFront: self.aadhaarFront, aadhaarBack: self.aadhaarBack } }
                    self.addDocumentsToApplication(document)
                }))
      },
        async addDocumentsToApplication(document){
          let self  = this
            NetworkCommunicator('POST',
                `${Constants.api_url}store/${this.$route.params.token}/${this.$route.params.applicationId}`, false,
                document).then(res => {
                if (res.flag) {
                    self.applicationDetail = res.data
                    self.$q.notify('Documents uploaded Successfully')
                    this.message = 'Documents uploaded Successfully'
                    this.dialog = true
                } else {
                    alert(res.message)
                }
            })
        },
      async getApplicationDetail () {
        let response = await NetworkCommunicator('POST',
          `${Constants.api_url}getApplication/${this.$route.params.token}/${this.$route.params.applicationId}`)
        if (response.flag) {
          this.applicationDetail = response.data
        } else {
          this.applicationDetail = response.data
          this.message = response.message
          this.dialog = true
        }

      },
    },
  }
</script>

<style scoped>
    .image-box{
        height: 350px;
        border: 2px dashed #c1c1c1;
        cursor: pointer;
        text-align: center;
        position: relative;
    }
    .icon-cloud{
        font-size: 40px;
        color: grey;
    }
</style>
